import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { T2TemplateBasicComponent } from 'app/trip2-theme/components/t2-template-basic/t2-template-basic.component';
import { ComplaintsResolutionComponent } from './complaints-resolution/complaints-resolution.component';
import { ComplaintsDashboardComponent } from './complaints-dashboard/complaints-dashboard.component';

const routes: Routes = [
  { path: 'pages', component: T2TemplateBasicComponent,
    children: [
      { path: 'complaints',
        children: [
          { path: 'complaints', component: ComplaintsResolutionComponent, data: { title: 'Complaints'} },
          { path: 'dashboard', component: ComplaintsDashboardComponent, data: { title: 'Complaints Dashboard' } }
        ]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class ComplaintsRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/pages/complaints/complaints-routing.module.ts